module.exports = __webpack_public_path__ + "img/wl_v3.3b526a5c.png";